import { useTranslation } from "react-i18next";
import React, { useState, useEffect, Fragment, useMemo, useRef, useLayoutEffect } from "react";
import { useNavigate } from "react-router-dom";
import apiRequest from "../../functions/api";
import {
  Paper,
  Typography,
  Table,
  Hidden,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Box,
  Grid,
  Card,
  IconButton,
  TextField,
  Autocomplete,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tooltip,
  TableSortLabel,
  DialogContentText,
} from "@mui/material";
import LoadingComponent from "../LoadingComponent/LoadingComponent";
import { useMessage } from "../../context/message-context";
import Layout from "../shared/components/LayoutComponent";
import Page from "../shared/components/PageComponent";
import ResponsiveDialog from "../shared/components/ResponsiveDialog";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { SearchTextField } from "../lib";
import RefreshIcon from "@mui/icons-material/Refresh";
import { API_BASE_URL } from "../../constants/apiConstants";
import axios from "axios";
import openFile from "../shared/functions/download";
import { FilterList } from "@mui/icons-material";
import ArchDialogWZKR from "./ArchDialogWZKR";

function AbsenceArch(props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [antraege, setAntraege] = useState({});
  const [filteredAntraege, setFilteredAntraege] = useState([]);
  const { accessToken, client } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [loadingWZKR, setLoadingWZKR] = useState(false);
  const { hideMessage, showErrorMessage } = useMessage();
  const [dialog, setDialog] = useState(false);
  const [dialogWZKR, setDialogWZKR] = useState();
  const [aktivWZKR, setAktivWZKR] = useState("");
  const [datenWZKR, setDatenWZKR] = useState([]);
  const [selectedElement, setSelectedElement] = useState();
  const [scrollPosition, setScrollPosition] = useState(() => {
    const storedScrollPosition = localStorage.getItem("scrollPositionAbsenceArch");
    return storedScrollPosition ? parseInt(storedScrollPosition, 10) : 0;
  });
  const tableRef = useRef(null);

  // Filter Vars
  const heute = new Date();
  const vorEinemMonat = new Date(heute.getFullYear(), heute.getMonth() - 1, heute.getDate()).toISOString().split("T")[0];
  const sechsMonateVorher = new Date(heute.getTime() - 6 * 30 * 24 * 60 * 60 * 1000);

  const storedFilterObject = JSON.parse(localStorage.getItem("AbsenceArchFilter"));
  const [suche, setSuche] = useState(storedFilterObject?.suche ? storedFilterObject?.suche : "");
  const [datumsFilter, setDatumsFilter] = useState(
    storedFilterObject?.datumsFilter != "" && storedFilterObject?.datumsFilter != undefined ? storedFilterObject?.datumsFilter : vorEinemMonat,
  );
  const [datumChecked, setDatumChecked] = useState(false);
  const [datumCofirm, setDatumConfirm] = useState(false);
  const [antragArtFilter, setAntragArtFilter] = useState(storedFilterObject?.antragArtFilter ? storedFilterObject?.antragArtFilter : []);
  const [statusFilter, setStatusFilter] = useState(storedFilterObject?.statusFilter ? storedFilterObject?.statusFilter : []);
  const [antragstellerFilter, setAntragstellerFilter] = useState(storedFilterObject?.antragstellerFilter ? storedFilterObject?.antragstellerFilter : []);
  const [vorgesetzterFilter, setVorgesetzterFilter] = useState(storedFilterObject?.vorgesetzterFilter ? storedFilterObject?.vorgesetzterFilter : []);
  const [filterDialog, setFilterDialog] = useState(false);
  const [order, setOrder] = useState(storedFilterObject?.order ? storedFilterObject?.order : "Start");
  const [startOrder, setStartOrder] = useState(storedFilterObject?.startOrder ? storedFilterObject?.startOrder : "asc");
  const [endeOrder, setEndeOrder] = useState(storedFilterObject?.endeOrder ? storedFilterObject?.endeOrder : "asc");
  const [mainData, setMainData] = useState(JSON.parse(localStorage.getItem("AbsenceArchData")) ? JSON.parse(localStorage.getItem("AbsenceArchData")) : {});

  useEffect(() => {
    const filterObject = {
      datumsFilter: datumsFilter,
      antragArtFilter: antragArtFilter,
      statusFilter: statusFilter,
      antragstellerFilter: antragstellerFilter,
      vorgesetzterFilter: vorgesetzterFilter,
      suche: suche,
      order: order,
      startOrder: startOrder,
      endeOrder: endeOrder,
    };
    localStorage.setItem("AbsenceArchFilter", JSON.stringify(filterObject));

    // Hier die Aufgaben filtern
    const result = Object.values(antraege)
      ?.filter((item) => {
        const tmpStatus = statusFilter?.length !== 0 ? statusFilter.some((searchItem) => searchItem.value === item.STATUS) : true;
        const tmpAntragArt = antragArtFilter?.length !== 0 ? antragArtFilter.some((searchItem) => searchItem.value === item.ART) : true;
        const tmpAntragsteller = antragstellerFilter?.length !== 0 ? antragstellerFilter.some((searchItem) => searchItem.value === item.ERSTELLT_VON) : true;
        const tmpVorgesetzter = vorgesetzterFilter?.length !== 0 ? vorgesetzterFilter.some((searchItem) => searchItem.value === item.BETROFFENER) : true;
        return tmpStatus && tmpAntragArt && tmpAntragsteller && tmpVorgesetzter;
      })
      .sort((a, b) => {
        if (order === "Start") {
          if (startOrder === "asc") {
            return b.BEGINN_DAT.localeCompare(a.BEGINN_DAT);
          } else {
            return a.BEGINN_DAT.localeCompare(b.BEGINN_DAT);
          }
        }
        if (order === "Ende") {
          if (endeOrder === "asc") {
            return b.ENDE_DAT.localeCompare(a.ENDE_DAT);
          } else {
            return a.ENDE_DAT.localeCompare(b.ENDE_DAT);
          }
        }
      });
    setFilteredAntraege(result);
  }, [antraege, suche, datumsFilter, statusFilter, antragstellerFilter, vorgesetzterFilter, antragArtFilter, order, startOrder, endeOrder]);

  useEffect(() => {
    if (Object.entries(mainData).length !== 0) {
      antragCb(mainData);
    }
  }, []);

  const aufgabenLaden = () => {
    if (datumsFilter === "") {
      showErrorMessage("Der Datumsfilter darf nicht leer sein.");
      return;
    }

    const tmpDate = new Date(datumsFilter);
    if (tmpDate < sechsMonateVorher && datumChecked === false) {
      setDatumConfirm(true);
      setDatumChecked(true);
      return;
    }
    setDatumChecked(false);

    setIsLoading(true);
    const payload = {
      mandant: client,
      program: "PMURA3",
      statement: "ARCHIV",
      datumsFilter: datumsFilter,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, antragCb);
  };

  useEffect(() => {
    if (Object?.keys(mainData)?.length !== 0) return;
    aufgabenLaden();
  }, []);

  // Use LayoutEffect damit die tableRef höchstwahrschenlich schon vorhanden ist
  useLayoutEffect(() => {
    // Wartet einen Frame länger damit MUI Table Zeit für den Render hat etc
    requestAnimationFrame(() => {
      if (!tableRef.current) return;
      tableRef.current.scrollTop = scrollPosition;
    });
  }, [antraege, tableRef]);

  const antragCb = (response) => {
    if (response.status === 200) {
      localStorage.setItem("AbsenceArchData", JSON.stringify(response));
      if (response.data.aufgaben) {
        setAntraege(response.data.aufgaben);
      } else {
        setAntraege([]);
      }
      setIsLoading(false);
      hideMessage();
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };

  const seitenwechsel = (element) => {
    element.TYP === "HDBD" && downloadPflichtdoc(element.AKTION_KEY);
    // element.TYP === "CSLT" &&  setRedirect("/WEBAGU/inviteKey/" + element.AKTION_KEY);
    element.TYP === "ANTRAG" && setRedirect("/PMURA3/antragsdetails/" + "000V" + element.AKTION_KEY);
    // element.TYP === "KORREKTUR" && setRedirect("/PMURA3/korrekturdetails/" + "000V" + element.AKTION_KEY);
    element.TYP === "SZ" && setRedirect("/SPLANT/" + "000V" + element.AKTION_KEY);
    element.TYP === "FORM" && setRedirect("/FORANT/" + element.AKTION_KEY);
    element.TYP === "FORMULAR" && setRedirect("/FORMUL/genehmigen/" + element.AKTION_KEY);
    if (element.TYP === "KORREKTUR") {
      setAktivWZKR(element.AKTION_KEY);
    }
    // element.TYP === "LHRZ" && setRedirect("/LTERW2/?haufKey=" + "000V" + element.AKTION_KEY);
    // element.TYP === "LHRZ" && setRedirect("/LTERW2/?hvktKey=" + "000V" + element.AKTION_KEY);

    if (element.art === "BONUS") {
      showErrorMessage(t("Der Entgeltantrag (Tag) ist nur noch in der alten ectool-App verfügbar. Diese können hier auch nicht eingesehen werden"));
    }
    if (element.TYP === "HABW") {
      setSelectedElement(element);
      setDialog(true);
    }
  };

  const setRedirect = (path) => {
    navigate(path);
  };

  const downloadPflichtdoc = (pflichtdok) => {
    const payload = {
      mandant: client,
      program: "WEBPDB",
      statement: "DATEI_LADEN",
      hdsakey: pflichtdok,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
      Accept: "application/pdf",
    };
    axios
      .post(API_BASE_URL + "daten", payload, {
        headers: headers,
        responseType: "blob",
      })
      .then((response) => {
        var contentFile = response.data;
        var contentDisposition = response.headers["content-disposition"];
        var fileName = contentDisposition.split("filename=")[1].trim().replace(/"/g, "");
        const mimeType = response.headers["Content-Type"] || "application/pdf";
        openFile(fileName, contentFile, mimeType);
      })
      .catch(function (error) {
        showErrorMessage("Ein Fehler ist aufgetreten. Bitte versuchen Sie den download erneut.");
      });
  };

  const handleScroll = (event) => {
    setScrollPosition(event.target.scrollTop);
    localStorage.setItem("scrollPositionAbsenceArch", event.target.scrollTop);
  };

  // Funktionen für den Filter
  const sucheChange = (value) => {
    setSuche(value);
  };

  const changeDatumFilter = (e) => {
    setDatumsFilter(e.target.value);
    aufgabenLaden();
  };

  const datumKeyPressed = (e) => {
    if (e.key == "Enter") {
      aufgabenLaden();
    }
  };

  const datumCofirmNein = () => {
    setDatumChecked(false);
    setDatumConfirm(false);
  };

  const datumCofirmJa = () => {
    setDatumConfirm(false);
    setMainData({});
    aufgabenLaden();
  };

  const setAntragArtFilterOptions = useMemo(() => {
    const tmpfilter = Object.values(antraege)
      ?.filter((value) => value.ART !== undefined && value.ART !== null)
      ?.filter((value, index, array) => array.findIndex((element) => element.ART === value.ART) === index)
      .map((mapElement) => ({
        value: mapElement.ART,
        label: mapElement.ART,
      }));

    if (tmpfilter === undefined) return [];
    return tmpfilter;
  }, [antraege]);

  const setStatusFilterOptions = useMemo(() => {
    const tmpfilter = Object.values(antraege)
      ?.filter((value) => value.STATUS !== undefined && value.STATUS !== null)
      ?.filter((value, index, array) => array.findIndex((element) => element.STATUS === value.STATUS) === index)
      .map((mapElement) => ({
        value: mapElement.STATUS.trim() === "" ? "" : mapElement.STATUS,
        label: mapElement.STATUS.trim() === "" ? t("Kein Status") : mapElement.STATUS,
      }));

    if (tmpfilter === undefined) return [];
    return tmpfilter;
  }, [antraege]);

  const setAntragstellerFilterOptions = useMemo(() => {
    const tmpfilter = Object.values(antraege)
      ?.filter((value, index, array) => array.findIndex((element) => element.ERSTELLT_VON === value.ERSTELLT_VON) === index)
      .map((mapElement) => ({
        value: mapElement.ERSTELLT_VON,
        label: mapElement.ERSTELLT_VON,
      }));

    if (tmpfilter === undefined) return [];
    return tmpfilter;
  }, [antraege]);

  const setVorgesetzterFilterOptions = useMemo(() => {
    const tmpfilter = Object.values(antraege)
      ?.filter((value, index, array) => array.findIndex((element) => element.BETROFFENER === value.BETROFFENER) === index)
      .map((mapElement) => ({
        value: mapElement.BETROFFENER,
        label: mapElement.BETROFFENER,
      }));

    if (tmpfilter === undefined) return [];
    return tmpfilter;
  }, [antraege]);

  const handleSort = (dir) => {
    setOrder(dir);
    if (dir == "Start") {
      if (startOrder === "asc") {
        setStartOrder("desc");
      } else {
        setStartOrder("asc");
      }
    }

    if (dir == "Ende") {
      if (endeOrder === "asc") {
        setEndeOrder("desc");
      } else {
        setEndeOrder("asc");
      }
    }
  };

  // Funktionen für Anträge aus WZKR

  useEffect(() => {
    if (aktivWZKR == "") {
      return;
    }
    setLoadingWZKR(true);
    setDialogWZKR(true);
    const payload = {
      mandant: client,
      program: "PMURA3",
      statement: "ARCHIV_WZKR",
      aktivKey: aktivWZKR,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };

    apiRequest("POST", "daten", payload, headers, wzkrCb);
  }, [aktivWZKR]);

  const wzkrCb = (response) => {
    setLoadingWZKR(false);
    if (response.status === 200) {
      setDatenWZKR(response.data.antraege);
      setAktivWZKR("");
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };

  if (isLoading) {
    return <LoadingComponent />;
  }

  const dataRequest =
    filteredAntraege?.length > 0 ? (
      filteredAntraege?.map((aufgabe) => {
        if (!suche || aufgabe.BEZEICHNUNG?.toLowerCase()?.includes(suche?.toLowerCase())) {
          return (
            <Fragment>
              <Hidden smDown>
                <TableHead></TableHead>
              </Hidden>
              <Hidden smUp>
                <TableHead></TableHead>
              </Hidden>
              <TableBody>
                <TableRow
                  key={aufgabe.key}
                  style={{ cursor: aufgabe.TYP ? "pointer" : "", backgroundColor: aufgabe.TYP ? "" : "lightgray" }}
                  onClick={() => seitenwechsel(aufgabe)}
                  hover
                >
                  <Hidden smDown>
                    <TableCell>
                      <Typography>{`${aufgabe.BEZEICHNUNG}`}</Typography>
                    </TableCell>
                    <TableCell>{aufgabe.ERSTELLT_VON}</TableCell>
                    <TableCell>{aufgabe.BETROFFENER}</TableCell>
                    <TableCell>{aufgabe.STATUS}</TableCell>
                    <TableCell>{`${aufgabe.BEGINN_DAT_TEXT}`}</TableCell>
                    <TableCell>{`${aufgabe.ENDE_DAT_TEXT}`}</TableCell>
                  </Hidden>
                  <Hidden smUp>
                    <TableCell>
                      <Typography variant="body1">{aufgabe.BEZEICHNUNG}</Typography>
                      <Typography variant="body1">{aufgabe.ERSTELLT_VON}</Typography>
                      <Typography variant="body1">{aufgabe.BETROFFENER}</Typography>
                      <Typography variant="body2">{aufgabe.STATUS}</Typography>
                      <Typography variant="body2">{`${aufgabe.BEGINN_DAT_TEXT} beantragt`}</Typography>
                      <Typography variant="body2">{`${aufgabe.ENDE_DAT_TEXT} bearbeitet`}</Typography>
                    </TableCell>
                  </Hidden>
                </TableRow>
              </TableBody>
            </Fragment>
          );
        }
      })
    ) : (
      <TableRow>
        <Hidden smUp>
          <TableCell>
            <Typography variant="body1">{t("Es wurden keine Anträge gefunden")}</Typography>
          </TableCell>
        </Hidden>
        <Hidden smDown>
          <TableCell colSpan={5}>
            <Typography variant="body1">{t("Es wurden keine Anträge gefunden")}</Typography>
          </TableCell>
        </Hidden>
      </TableRow>
    );

  return (
    <Page>
      <Layout fullWidth>
        <Box p={2}>
          <Typography color="primary" variant="h4">
            {t("Meldungen/Anträge Archiv")}
          </Typography>
        </Box>
      </Layout>

      <Grid container justifyContent="center">
        <Grid item xs={12} md={10} lg={8}>
          <Grid container justifyContent="flex-start" alignItems="center" spacing={1}>
            <Grid item xs={12}>
              {/* Desktop */}
              <Box sx={{ display: { xs: "none", sm: "none", md: "block" } }}>
                <Grid container justifyContent="center" spacing={1} style={{ paddingTop: 20 }}>
                  <Grid item xs={12} md={1.5}>
                    <SearchTextField
                      size="small"
                      fullWidth
                      label={t("Suche")}
                      id="filter"
                      variant="outlined"
                      value={suche}
                      inputProps={{
                        autoCapitalize: "off",
                        autoCorrect: "off",
                        spellCheck: "false",
                        autoComplete: "off",
                      }}
                      onChange={(e) => sucheChange(e.target.value)}
                    />
                  </Grid>

                  <Grid item xs={12} md={1.5}>
                    <TextField
                      fullWidth
                      id="datumFilter"
                      size="small"
                      type="date"
                      label={"Aufgaben holen von [Datum] bis heute"}
                      value={datumsFilter}
                      onKeyDown={(e) => datumKeyPressed(e)}
                      onBlur={aufgabenLaden}
                      onChange={(e) => setDatumsFilter(e.target.value)}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} md={2}>
                    <Autocomplete
                      multiple
                      onChange={(event, newValue) => {
                        setAntragArtFilter(newValue);
                      }}
                      value={antragArtFilter}
                      size="small"
                      id="tags-outlined"
                      options={setAntragArtFilterOptions}
                      getOptionLabel={(option) => option.label}
                      renderInput={(params) => <TextField {...params} label="Nach Antragart filtern" placeholder="Antragart" />}
                    />
                  </Grid>

                  <Grid item xs={12} md={2}>
                    <Autocomplete
                      multiple
                      onChange={(event, newValue) => {
                        setAntragstellerFilter(newValue);
                      }}
                      value={antragstellerFilter}
                      size="small"
                      id="tags-outlined"
                      options={setAntragstellerFilterOptions}
                      getOptionLabel={(option) => option.label}
                      renderInput={(params) => <TextField {...params} label="Nach Antragsteller filtern" placeholder="Antragsteller" />}
                    />
                  </Grid>

                  <Grid item xs={12} md={2}>
                    <Autocomplete
                      multiple
                      onChange={(event, newValue) => {
                        setVorgesetzterFilter(newValue);
                      }}
                      value={vorgesetzterFilter}
                      size="small"
                      id="tags-outlined"
                      options={setVorgesetzterFilterOptions}
                      getOptionLabel={(option) => option.label}
                      renderInput={(params) => <TextField {...params} label="Bearbeitet von filtern" placeholder="Bearbeitet von" />}
                    />
                  </Grid>

                  <Grid item xs={12} md={2}>
                    <Autocomplete
                      multiple
                      onChange={(event, newValue) => {
                        setStatusFilter(newValue);
                      }}
                      value={statusFilter}
                      size="small"
                      id="tags-outlined"
                      options={setStatusFilterOptions}
                      getOptionLabel={(option) => option.label}
                      renderInput={(params) => <TextField {...params} label="Nach Status filtern" placeholder="Status" />}
                    />
                  </Grid>

                  <Grid item xs={12} md={1}>
                    <IconButton color="primary" onClick={aufgabenLaden}>
                      <RefreshIcon />
                    </IconButton>
                  </Grid>
                </Grid>
              </Box>

              {/* Mobile */}
              <Box sx={{ display: { xs: "block", sm: "block", md: "none" } }}>
                <Box display="flex" alignItems={"center"}>
                  <SearchTextField
                    size="small"
                    fullWidth
                    label={t("Suche")}
                    id="filter"
                    variant="outlined"
                    value={suche}
                    inputProps={{
                      autoCapitalize: "off",
                      autoCorrect: "off",
                      spellCheck: "false",
                      autoComplete: "off",
                    }}
                    onChange={(e) => sucheChange(e.target.value)}
                  />

                  <Box pr={1}>
                    <Tooltip title="Filter">
                      <IconButton color="primary" onClick={() => setFilterDialog(true)}>
                        <FilterList />
                      </IconButton>
                    </Tooltip>
                  </Box>

                  <Box pr={1}>
                    <IconButton color="primary" onClick={aufgabenLaden}>
                      <RefreshIcon />
                    </IconButton>
                  </Box>

                  <Dialog open={filterDialog} onClose={() => setFilterDialog(false)} maxWidth="md" fullWidth>
                    <DialogTitle>Filter</DialogTitle>
                    <DialogContent>
                      <Grid container justifyContent="center" spacing={1} style={{ paddingTop: 20 }}>
                        <Grid item xs={12} md={5}></Grid>

                        {/* Fürs Handy mal noch mit dem Handy wirkliich testen wie sich das verhält!!!! */}
                        <Grid item xs={12} md={3}>
                          <TextField
                            fullWidth
                            id="datumFilter"
                            size="small"
                            type="date"
                            label={"Aufgaben holen von [Datum] bis heute"}
                            value={datumsFilter}
                            onKeyDown={(e) => datumKeyPressed(e)}
                            onChange={(e) => changeDatumFilter(e)}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        </Grid>

                        <Grid item xs={12} md={2}>
                          <Autocomplete
                            multiple
                            onChange={(event, newValue) => {
                              setAntragArtFilter(newValue);
                            }}
                            value={antragArtFilter}
                            size="small"
                            id="tags-outlined"
                            options={setAntragArtFilterOptions}
                            getOptionLabel={(option) => option.label}
                            renderInput={(params) => <TextField {...params} label="Nach Antragart filtern" placeholder="Antragart" />}
                          />
                        </Grid>

                        <Grid item xs={12} md={2}>
                          <Autocomplete
                            multiple
                            onChange={(event, newValue) => {
                              setAntragstellerFilter(newValue);
                            }}
                            value={antragstellerFilter}
                            size="small"
                            id="tags-outlined"
                            options={setAntragstellerFilterOptions}
                            getOptionLabel={(option) => option.label}
                            renderInput={(params) => <TextField {...params} label="Nach Antragsteller filtern" placeholder="Antragsteller" />}
                          />
                        </Grid>

                        <Grid item xs={12} md={2}>
                          <Autocomplete
                            multiple
                            onChange={(event, newValue) => {
                              setVorgesetzterFilter(newValue);
                            }}
                            value={vorgesetzterFilter}
                            size="small"
                            id="tags-outlined"
                            options={setVorgesetzterFilterOptions}
                            getOptionLabel={(option) => option.label}
                            renderInput={(params) => <TextField {...params} label="Bearbeitet von filtern" placeholder="Bearbeitet von" />}
                          />
                        </Grid>

                        <Grid item xs={12} md={2}>
                          <Autocomplete
                            multiple
                            onChange={(event, newValue) => {
                              setStatusFilter(newValue);
                            }}
                            value={statusFilter}
                            size="small"
                            id="tags-outlined"
                            options={setStatusFilterOptions}
                            getOptionLabel={(option) => option.label}
                            renderInput={(params) => <TextField {...params} label="Nach Status filtern" placeholder="Status" />}
                          />
                        </Grid>
                      </Grid>
                    </DialogContent>
                    <DialogActions>
                      <Button style={{ marginRight: "10px" }} variant="secondary" display="flex" onClick={() => setFilterDialog(false)}>
                        {t("Abbrechen")}
                      </Button>
                    </DialogActions>
                  </Dialog>
                </Box>
              </Box>

              <Card>
                <Box p={2}>
                  <TableContainer ref={tableRef} onScroll={handleScroll} sx={{ maxHeight: window.innerHeight - 300 }} component={Paper}>
                    <Table id="antragTable" stickyHeader>
                      <Hidden smDown>
                        <TableHead>
                          <TableRow>
                            <TableCell>{t("Art des Antrags")}</TableCell>
                            <TableCell>{t("Antragsteller")}</TableCell>
                            <TableCell>{t("Bearbeitet von")}</TableCell>
                            <TableCell>{t("Status")}</TableCell>
                            <TableCell>
                                  <TableSortLabel active={order == "Start"} direction={startOrder} onClick={() => handleSort("Start")}>
                                    {t("Beantragt am")}
                                  </TableSortLabel>
                            </TableCell>
                             <TableCell>
                                  <TableSortLabel active={order == "Ende"} direction={endeOrder} onClick={() => handleSort("Ende")}>
                                    {t("Bearbeitet am")}
                                  </TableSortLabel>
                            </TableCell>
                          </TableRow>
                        </TableHead>
                      </Hidden>
                      {dataRequest}
                    </Table>
                  </TableContainer>
                </Box>
              </Card>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <ResponsiveDialog
        title={t("Arbeitsunfähigkeit wurde zu Kenntnis genommen")}
        open={dialog}
        setOpen={(o) => {
          setDialog(false);
        }}
      >
        <Box p={1}>
          <Grid container justifyContent="center">
            <Grid item xs={12}>
              <Grid container justifyContent="center" spacing={2}>
                <Grid item xs={12} sm={12}>
                  <Box sx={{ padding: 2 }}>
                    <Typography>
                      Die Arbeitsunfähigkeit von {selectedElement?.ERSTELLT_VON} wurde am {selectedElement?.ENDE_DAT_TEXT} von {selectedElement?.BETROFFENER}{" "}
                      zur Kenntnis genommen.
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Button color="primary" variant="outlined" fullWidth onClick={() => setDialog(false)}>
                    {t("Fertig")}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </ResponsiveDialog>

      <ArchDialogWZKR dialog={dialogWZKR} setDialog={setDialogWZKR} datenWZKR={datenWZKR} setDatenWZKR={setDatenWZKR} isLoading={loadingWZKR}></ArchDialogWZKR>

      <Dialog open={datumCofirm} onClose={datumCofirmNein} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">{"Sicher?"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">Das Datum ist länger her als 6 Monate. Die Ladezeit könnte länger ausfallen!</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={datumCofirmNein}>Abbrechen</Button>
          <Button variant="contained" color="primary" onClick={datumCofirmJa} autoFocus>
            Daten laden
          </Button>
        </DialogActions>
      </Dialog>
    </Page>
  );
}
export default AbsenceArch;
